<template>
    <div id="app" v-show="show">
        <router-view />
    </div>
</template>

<script>
import { getUrlData } from '@/utils/utils';
export default {
    name: 'App',
    data() {
        return{
            show: false
        }
    },
    created() {
        let code = getUrlData('code');
        if(code){
            this.show = false;
        }else{
            this.show = true;
        }
    }
};
</script>

<style lang="scss">
html, body, #app {
    height: 100%;
}
</style>
